<form [formGroup]="productForm" >

    <table>
        <tr>
            <td style="width: 125px;padding-left: 5px;"><button class="buttonHeaderHome" (click)="DivEditVul()" autofocus >Edit Vulnerability Record</button></td>                                              
            <td style="width: 125px;padding-left: 5px;"><button class="buttonHeaderHome" (click)="DivRiskVal()">Risk Validation</button></td>                                              
        </tr>   
    </table>
    <div *ngIf="isShown">
        <div class="catcontainer" style="margin-left: 5px;width:1045px;margin-top: 10px;height: fit-content;border-radius: 20px;" >
    <table>
        <tr><h3 style="font-weight: 500;margin-left: 5px;margin-top: 15px">Vulnerability Details</h3></tr>
    </table>
        <table style="margin-left: 5px">        
    <tr>
        <td ><label style="width:100px;font-weight: 600;">Client</label></td> 
        <td ><label style="width:100px;font-weight: 600;">Contract</label></td> 
        <td ><label style="width:100px;font-weight: 600;">Contract Name</label></td> 
        <td ><label style="width:100px;font-weight: 600;">Title</label></td> 
    </tr>
    <tr>
          
        <td>
            <mat-form-field class="width" appearance="outline">
                <mat-select [formControl]="ClientServerSideCtrl" id="ClientServerSideCtrl" placeholder="Client" #matClient>
                  
                <mat-option>
                    <ngx-mat-select-search [formControl]="ClientServerSideFilteringCtrl" placeholderLabel="Find Client..."
                        noEntriesFoundLabel="'No matching Client found'"></ngx-mat-select-search>
                </mat-option>
                  <mat-option *ngFor="let Clientopt of filteredClient | async" [value]="Clientopt" >
                    {{Clientopt}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </td>
        <td>
            <mat-form-field class="width" appearance="outline">
                <mat-select [formControl]="ContNumServerSideCtrl" placeholder="Contract" #matContract>
                  
                <mat-option>
                    <ngx-mat-select-search [formControl]="ContNumServerSideFilteringCtrl" placeholderLabel="Find Contract..."
                        noEntriesFoundLabel="'No matching Contract found'"></ngx-mat-select-search>
                </mat-option>
                  <mat-option *ngFor="let ContNumopt of filteredContNum | async" [value]="ContNumopt" >
                    {{ContNumopt}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </td>
        <td>
            <mat-form-field class="width" appearance="outline">
                <mat-select [formControl]="ContNameServerSideCtrl" placeholder="Contract Name" #matContName>
                  <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
                <mat-option>
                    <ngx-mat-select-search [formControl]="ContNameServerSideFilteringCtrl" placeholderLabel="Find Contract..."
                        noEntriesFoundLabel="'No matching Contract found'"></ngx-mat-select-search>
                </mat-option>
                  <mat-option *ngFor="let ContNameopt of filteredContName | async" [value]="ContNameopt" >
                    {{ContNameopt}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </td>
        <td>
            <mat-form-field class="width" appearance="outline">
                <mat-select [formControl]="bankServerSideCtrl" placeholder="Title" #matTitle>
                  <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
                <mat-option>
                    <ngx-mat-select-search [formControl]="bankServerSideFilteringCtrl" placeholderLabel="Find Title..."
                        noEntriesFoundLabel="'No matching Title found'"></ngx-mat-select-search>
                </mat-option>
                  <mat-option *ngFor="let bank of filteredServerSideBanks | async" [value]="bank" >
                    {{bank}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </td>
        <td>
            <button (click)="FilterSearch()" style="margin-left: 5px;" class="buttonnewvul">Search</button>
            <button (click)="ClearDD()" style="margin-bottom: 30px;margin-left:5px;" class="buttonnewvul">Clear</button>         
             <!-- <a *ngFor="let lang of EmailData" href="mailto:{{lang.AddressTo}}?cc={{lang.AddressCC}}&subject={{lang.EmailSubject}}" style="text-decoration: none !important;line-height: 17px;margin-top:15px;" class="btn buttonnewvul">Request to GCC</a> -->
        </td>
    </tr>
    <tr style="display: none;"> 
        <td>
            <mat-form-field appearance="outline">
                <mat-label>Select</mat-label>
                <mat-select id="ClientDD" formControlName="ClientDD" >
                    <mat-option *ngFor="let lang of DDdataEVClient" value="{{lang.Client}}">  
                    {{lang.Client}}</mat-option>                
                </mat-select>             
            </mat-form-field> 
        </td>   
    
        <td>
            <mat-form-field appearance="outline">
                <mat-label>Select</mat-label>
                <mat-select id="ContractDD"  formControlName="ContractDD"  >
                    <mat-option *ngFor="let lang of DDdataEVContrNum" value="{{lang.ContractNumber}}">  
                    {{lang.ContractNumber}}</mat-option>                
                </mat-select>             
            </mat-form-field> 
        </td>
        <td>
            <mat-form-field appearance="outline">
                <mat-label>Select</mat-label>
                <mat-select id="ContNameDD"  formControlName="ContNameDD"  >
                    <mat-option *ngFor="let lang of DDdataEVContrName" value="{{lang.ContractName}}">  
                    {{lang.ContractName}}</mat-option>                
                </mat-select>             
            </mat-form-field> 
        </td>
        <td>
            <mat-form-field appearance="outline">
                <mat-label>Select</mat-label>
                <mat-select id="CVEDD"   formControlName="CVEDD" >
                    <mat-option *ngFor="let lang of DDdataEVCVE" value="{{lang.CVE}}">  
                    {{lang.CVE}}</mat-option>                
                </mat-select>             
            </mat-form-field> 
        </td>  
        <!-- <td>
        <mat-form-field class="width" appearance="outline">
            <input matInput placeholder="Title" 
              [matAutocomplete]="auto" [formControl]="CVEDDNew1" id="CVEDDNew1" formControlName="CVEDDNew1" (keyup)="onSearchTitleKeyDown($event)" 
              #choosedValue1/>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option
                *ngFor="let lang of filteredOptions "
                [value]="lang">
                {{ lang.CVE }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </td> -->
        <td>
            <mat-form-field class="width" appearance="outline">
                <mat-select [formControl]="bankServerSideCtrl" placeholder="Title" #singleSelect>
                  <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
                <mat-option>
                    <ngx-mat-select-search [formControl]="bankServerSideFilteringCtrl" placeholderLabel="Find Title..."
                        noEntriesFoundLabel="'No matching Title found'"></ngx-mat-select-search>
                </mat-option>
                  <mat-option *ngFor="let bank of filteredServerSideBanks | async" [value]="bank" >
                    {{bank}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </td>
        <td>
            <button (click)="FilterSearch()" style="margin-left: 5px;" class="buttonnewvul">Search</button>
            <button (click)="ClearDD()" style="margin-bottom: 30px;margin-left:5px;" class="buttonnewvul">Clear</button>         
             <!-- <a *ngFor="let lang of EmailData" href="mailto:{{lang.AddressTo}}?cc={{lang.AddressCC}}&subject={{lang.EmailSubject}}" style="text-decoration: none !important;line-height: 17px;margin-top:15px;" class="btn buttonnewvul">Request to GCC</a> -->
        </td>
    </tr>
    
        </table>
    </div>
        <div *ngIf="!isShownEV" style="margin-top: 10px;">
        <table formArrayName="contracts_arrayEV" class="client" id="EditTable1" >
            <tr align="center">
                <td ><label style="width:225px;font-weight: 600;">Client</label></td> 
                <td><label style="width:225px;;font-weight: 600;">Contract/Contract Name</label></td> 
                <td style="display:none;"><label style="width:150px;font-weight: 600;">CVE</label></td> 
                <td style="width:100px;font-weight: 600;"><label style="width:90px">Accenture manage the technology?</label></td>                                
                <td style="width:100px;font-weight: 600;"><label style="width:90px">Accenture manage the impacted version?</label></td>   
                <td><label style="width:100px;font-weight: 600;">CDP approved exception?</label></td>                              
                <td><label style="width:100px;font-weight: 600;">Recommended patch or workaround Installed?</label></td> 
                <td><label style="width:150px;font-weight: 600;">Planned remediation date</label></td> 
                
                
                <td style="width:100px;;font-weight: 600;"><label>Vulnerability Exploited?</label></td>  
                <td style="display:none"><label style="width:100px;font-weight: 600;">Senior Client formally Informed?</label></td> 
                <td ><label style="width:150px;font-weight: 600;">Vulnerability Record Status</label></td>                                 
                <td style="display:none"><label style="width:275px;font-weight: 600;">Please provide mitigation comments or additional information(unless fixed or not used and informed client etc)</label></td>                                   
            </tr>
    
            <tr *ngFor="let contractEV of contractsmethodEV().controls; let k=index" [formGroupName]="k">                            
                <td style="width:225px" align="center">                                 
               <input matInput style="text-overflow: ellipsis" id="clientEV" formControlName="clientEV" [readonly] = "disableSelect">
           </td>
           <td style="width:225px" align="center">                            
           <input matInput style="text-overflow: ellipsis" id="contractEV"  formControlName="contractEV" [readonly] = "disableSelect">  /      
       <input matInput style="text-overflow: ellipsis"id="contract_nameEV"   formControlName="contract_nameEV" [readonly] = "disableSelect">
    </td>
    <td style="width:150px;display:none;" align="center">
        <input matInput style="text-overflow: ellipsis"id="cveEV"   formControlName="cveEV" [readonly] = "disableSelect">
     </td>
    <td align="center">                        
       <mat-form-field appearance="outline" style="width:90px;margin-top: 15px;">
           <mat-label>Select</mat-label>
           <mat-select id="DoAccManageEV{{k}}" formControlName="DoAccManageEV"  name="DoAccManageEV" (selectionChange)="onDrpChange($event.source.id,$event.value)">                            
               <mat-option value="Yes">Yes</mat-option>
               <mat-option value="No">No</mat-option>                            
           </mat-select>
       </mat-form-field>
    </td>  
    <td align="center">                        
        <mat-form-field appearance="outline" style="width:90px;margin-top: 15px;">
            <mat-label>Select</mat-label>
            <mat-select id="AccImpactVersion{{k}}" formControlName="AccImpactVersion"  name="AccImpactVersion" (selectionChange)="onDrpChange($event.source.id,$event.value)">                            
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="No">No</mat-option>                            
            </mat-select>
        </mat-form-field>
     </td>
     <td align="center">                        
        <mat-form-field appearance="outline" style="width:90px;margin-top: 15px;">
            <mat-label>Select</mat-label>
            <mat-select id="ClientAppExcepEV{{k}}" formControlName="ClientAppExcepEV" name="ClientAppExcepEV" (selectionChange)="onDrpChange($event.source.id,$event.value)">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="No">No</mat-option>
                <mat-option value="N/A">N/A</mat-option>
            </mat-select>
        </mat-form-field>
     </td>  
    <td align="center">                        
    <mat-form-field appearance="outline" style="width:90px;margin-top: 15px;">
        <mat-label>Select</mat-label>
        <mat-select id="AppliedCorrActionEV{{k}}" formControlName="AppliedCorrActionEV" name="AppliedCorrActionEV" (selectionChange)="onDrpChange($event.source.id,$event.value)">
            <!-- <mat-option value="Yes">Yes</mat-option> -->
            <mat-option value="No">No</mat-option>
            <mat-option value="Patch applied">Patch applied</mat-option>
            <mat-option value="Workaround applied">Workaround applied</mat-option>
        </mat-select>
    </mat-form-field>
    </td>  
    <td align="center">                                                    
       <mat-form-field appearance="outline" style="width:150px;margin-top: 15px;">
           <mat-label>Choose a date</mat-label>
           <input matInput [matDatepicker]="picker"  id="RemediationDateEV{{k}}" formControlName="remediationraisedEV">
           <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
           <mat-datepicker #picker></mat-datepicker>
         </mat-form-field>
    </td> 
    
    
    <td align="center" >                        
       <mat-form-field appearance="outline" style="width:90px;margin-top: 15px;" >
           <mat-label>Select</mat-label>
           <mat-select id="ClientImpEV{{k}}" formControlName="ClientImpEV"  name="ClientImpEV" (selectionChange)="onDrpChange($event.source.id,$event.value)">
               <mat-option value="Yes">Yes</mat-option>
               <mat-option value="No">No</mat-option>                            
           </mat-select>
       </mat-form-field>
    </td>
    <td align="center" style="display:none">                        
        <mat-form-field appearance="outline" style="width:90px;margin-top: 15px;">
            <mat-label>Select</mat-label>
            <mat-select  id="ClientInfEV{k}" formControlName="ClientInfEV" name="ClientInfEV">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="No">No</mat-option>                            
            </mat-select>
        </mat-form-field>
     </td> 
    <td align="center">                        
       <mat-form-field appearance="outline" style="width:150px;margin-top: 15px;" >
           <mat-label>Select</mat-label>
           <mat-select id="VulRecordStatusEV{{k}}" formControlName="VulRecordStatusEV"  name="VulRecordStatusEV">
               <mat-option value="Complete">Complete</mat-option>
               <mat-option value="In Progress">In Progress</mat-option> 
               <mat-option value="Past Due Date">Past Due Date</mat-option>                            
               <mat-option value="Risk Validation">Risk Validation</mat-option> 
           </mat-select>
       </mat-form-field>
    </td>    
    <td align="center" style="display:none">
        <mat-form-field id="MitigationCommentOuter{k}"appearance="outline" style="width: 275px;border-radius: 5px;height:50px">                            
            <textarea matInput maxlength="500" id="MitigationComment{k}" formControlName="MitigationComment" name="MitigationComment"  style="height:50px; color: black;border-radius: 10px;padding-top: 5px;padding-bottom: 5px;text-align: center;white-space: normal;overflow-x: hidden">
            </textarea>
        </mat-form-field>
    </td>                         					
           </tr>
        </table>
        <table align="center" id="EditTable2">
            <tr >
                <td>
                 <button (click)="SubmitEV()" id="SaveEV"  class="buttonnewvul">Save</button>
                 <button style="margin-left:5px;" (click)="ClearDD()" id="CancelEV"  class="buttonnewvul">Cancel</button>
                </td>
            </tr>
        </table>
    </div> 
    
        
    </div>
    
    <div *ngIf="!isShown">
    <table  formArrayName="quantities">  
    
      <tr><h3 style="font-weight: 500;margin-left: 5px">Vulnerability Details</h3></tr>
      <tr>
        <td>
            <mat-form-field class="width" appearance="outline">
                <mat-select [formControl]="RiskTitleServerSideCtrl" placeholder="Title" #matRiskTitle>
                <mat-option>
                    <ngx-mat-select-search [formControl]="riskTitleServerSideFilteringCtrl" placeholderLabel="Find Title..."
                        noEntriesFoundLabel="'No matching Title found'"></ngx-mat-select-search>
                </mat-option>
                  <mat-option *ngFor="let riskTitle of filteredRiskTitle | async" [value]="riskTitle" >
                    {{riskTitle}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </td>
        <td>
            <button (click)="FilterRiskTitleSearch()" style="margin-left: -1130px;" class="buttonnewvul">Search</button>
            <button (click)="ClearRiskDD()" style="margin-bottom: 30px;margin-left:5px;" class="buttonnewvul">Clear</button>         
             <!-- <a *ngFor="let lang of EmailData" href="mailto:{{lang.AddressTo}}?cc={{lang.AddressCC}}&subject={{lang.EmailSubject}}" style="text-decoration: none !important;line-height: 17px;margin-top:15px;" class="btn buttonnewvul">Request to GCC</a> -->
        </td>
      </tr>
      <tr>
          <td>        
              <label style="font-weight: 600;margin-left: 30px;">Title</label>         
          </td>
      </tr>
      <tr *ngFor="let quantity of quantities().controls; let i=index" [formGroupName]="i">
    
        <td>     
          <mat-expansion-panel  style="width: 1365px;" #matExpansionPanel>                    
            <mat-expansion-panel-header>
                <mat-panel-title>                                                      
            <table> 
                <tr style="height:25px"></tr>        
                
                <tr>
                    <td>                                      
                        <mat-form-field appearance="outline" style="width: 1300px;">
                            <mat-label></mat-label>
                            <input matInput style="width: 1300px;"id="title{{i}}" [readonly] = "disableSelect" name="title"  class="form-control" formControlName="Vulnerability_Title" value="Codecov Software - Bash Uploader Exploitation"   >
                        </mat-form-field>
                    </td>
                </tr>
                </table>
                
            </mat-panel-title>
            <input type="hidden" id="VID{{i}}" class="form-control" formControlName="VID">
            
        </mat-expansion-panel-header>                       
    
                    <table  class="client example col1-readonly col2-readonly col4-readonly LezzonPrize" style="width: 1320px;"  formArrayName="contracts_array">                    
                        <tr align="center">
                        <td ><label style="width:250px;font-weight: 600;">Client</label></td> 
                        <td><label style="width:150px;;font-weight: 600;">Contract</label></td> 
                        <td><label style="width:250px;font-weight: 600;">Contract Name</label></td> 
                        <td id="accManage" style="width:90px;font-weight: 600;"><label style="width:90px">Vulnerability Record Status</label></td>                                
                        <td><label style="width:50px;font-weight: 600;">Validate</label></td>                               
                        </tr>
    
                        <tr *ngFor="let contract of contractsmethod(i).controls; let j=index" [formGroupName]="j">                            
                             <td style="width:100px" align="center">                                 
                            <input matInput id="client" formControlName="client" [readonly] = "disableSelect">
                        </td>
                            <td style="width:150px" align="center">                            
                            <input matInput style="text-overflow: ellipsis" id="contract"  formControlName="contract" [readonly] = "disableSelect">
                        </td>
                        <td style="width:150px;;" align="center">
                        <input matInput style="text-overflow: ellipsis"id="contract_name"   formControlName="contract_name" [readonly] = "disableSelect">
                            </td>
                        <td style="width:150px;;" align="center">
                            <input matInput style="text-overflow: ellipsis"id="VulRecordStatus{{j}}"   formControlName="VulRecordStatus" [readonly] = "disableSelect">
                            </td>       
                        <td style="width:150px;;" align="center">
                                <mat-checkbox class="example-margin" color="primary"  formControlName="Validate"></mat-checkbox>
                            </td> 
                        </tr>                     
                                 
                    </table>
    
                    <br/>
                      
                        <div style="width: 1376px;text-align:center;">
                            
                            <!-- <button (click)="onSubmit($event)" id="{{i}}" *ngIf="!Hidebtn" class="buttonnewvul">Save</button> -->
                            <button (click)="onSubmit($event)" id="{{i}}" style="margin-left: 5px;" class="buttonnewvul">Save</button>
                            </div>                                                                                 
    </mat-expansion-panel>                
        </td>
      </tr> 
      </table>
    </div>          
    </form>
    <ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>